/**
 * @generated SignedSource<<406796540bf95c35ee1b40c7b0b1232c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ToolCallSheet_toolCall$data = {
  readonly toolResult: {
    readonly artifactId: string | null | undefined;
    readonly commandFailed: boolean | null | undefined;
    readonly content: string;
    readonly ephemeral: boolean | null | undefined;
    readonly groupTags: ReadonlyArray<string> | null | undefined;
    readonly hasData: boolean | null | undefined;
  } | null | undefined;
  readonly toolUse: {
    readonly capability: {
      readonly id: any;
      readonly name: string;
      readonly parametersSchema: any;
    } | null | undefined;
    readonly capabilityId: number | null | undefined;
    readonly displayName: string | null | undefined;
    readonly id: string;
    readonly input: {
      readonly __typename: "BuildkiteAnnotationsToolInput";
      readonly buildNumberInt: number;
      readonly contextFilter: ReadonlyArray<string> | null | undefined;
      readonly pipelineSlug: string;
      readonly question: string;
    } | {
      readonly __typename: "BuildkiteArtifactsToolInput";
      readonly artifactPath: string;
      readonly buildNumberInt: number;
      readonly jobName: string | null | undefined;
      readonly pipelineSlug: string;
      readonly question: string;
      readonly searchQuery: string;
      readonly stepKey: string | null | undefined;
    } | {
      readonly __typename: "BuildkiteBuildsToolInput";
      readonly buildNumberStr: string | null | undefined;
      readonly pipelineSlug: string;
      readonly queryParams: string | null | undefined;
      readonly question: string;
    } | {
      readonly __typename: "BuildkiteFlakyTestToolInput";
      readonly question: string;
      readonly testName: string;
      readonly testSuiteSlug: string;
    } | {
      readonly __typename: "BuildkiteLogsToolInput";
      readonly buildNumberInt: number;
      readonly pipelineSlug: string;
      readonly question: string;
      readonly retryTypeFilter: ReadonlyArray<string> | null | undefined;
      readonly stateFilter: ReadonlyArray<string> | null | undefined;
    } | {
      readonly __typename: "CloudWatchLogsAggregationToolInput";
      readonly cwLogsAggEndIsoStr: string;
      readonly cwLogsAggStartIsoStr: string;
      readonly logGroupNames: ReadonlyArray<string>;
      readonly query: string;
      readonly question: string;
    } | {
      readonly __typename: "CloudWatchLogsToolInput";
      readonly cwLogsEndIsoStr: string;
      readonly cwLogsStartIsoStr: string;
      readonly logGroupNames: ReadonlyArray<string>;
      readonly query: string;
      readonly question: string;
    } | {
      readonly __typename: "CloudWatchMetricsToolInput";
      readonly cwMetricsEndIsoStr: string;
      readonly cwMetricsStartIsoStr: string;
      readonly query: string;
      readonly question: string;
    } | {
      readonly __typename: "DatadogCIPipelineEventsAggregationToolInput";
      readonly ddCIPipelineAggEndIsoStr: string;
      readonly ddCIPipelineAggStartIsoStr: string;
      readonly query: string;
      readonly question: string;
    } | {
      readonly __typename: "DatadogCIPipelineEventsToolInput";
      readonly ddCIPipelineEndIsoStr: string;
      readonly ddCIPipelineStartIsoStr: string;
      readonly query: string;
      readonly question: string;
    } | {
      readonly __typename: "DatadogDashboardToolInput";
      readonly ddDashboardId: string;
      readonly question: string;
    } | {
      readonly __typename: "DatadogErrorTrackingIssueDetailsToolInput";
      readonly issueId: string;
      readonly question: string;
    } | {
      readonly __typename: "DatadogErrorTrackingIssuesToolInput";
      readonly ddErrorTrackingEndIsoStr: string;
      readonly ddErrorTrackingStartIsoStr: string;
      readonly persona: string;
      readonly query: string;
      readonly question: string;
      readonly track: string | null | undefined;
    } | {
      readonly __typename: "DatadogEventsToolInput";
      readonly ddEventsEndIsoStr: string;
      readonly ddEventsStartIsoStr: string;
      readonly query: string;
      readonly question: string;
    } | {
      readonly __typename: "DatadogLogsAggregationToolInput";
      readonly ddLogsAggEndIsoStr: string;
      readonly ddLogsAggStartIsoStr: string;
      readonly query: string;
      readonly question: string;
    } | {
      readonly __typename: "DatadogLogsToolInput";
      readonly ddLogsEndIsoStr: string;
      readonly ddLogsStartIsoStr: string;
      readonly query: string;
      readonly question: string;
    } | {
      readonly __typename: "DatadogMetricsToolInput";
      readonly ddMetricsEndIsoStr: string;
      readonly ddMetricsStartIsoStr: string;
      readonly query: string;
      readonly question: string;
    } | {
      readonly __typename: "DatadogMonitorToolInput";
      readonly monitorId: number;
      readonly question: string;
    } | {
      readonly __typename: "DatadogNotebookToolInput";
      readonly notebookId: string;
      readonly question: string;
    } | {
      readonly __typename: "DatadogRumAggregationToolInput";
      readonly ddRumAggEndIsoStr: string;
      readonly ddRumAggStartIsoStr: string;
      readonly query: string;
      readonly question: string;
    } | {
      readonly __typename: "DatadogServiceDependencyToolInput";
      readonly question: string;
      readonly serviceName: string;
    } | {
      readonly __typename: "DatadogSpansAggregationToolInput";
      readonly ddSpansAggEndIsoStr: string;
      readonly ddSpansAggStartIsoStr: string;
      readonly query: string;
      readonly question: string;
    } | {
      readonly __typename: "DatadogSpansToolInput";
      readonly ddSpansEndIsoStr: string;
      readonly ddSpansStartIsoStr: string;
      readonly query: string;
      readonly question: string;
    } | {
      readonly __typename: "FetchWebContentToolInput";
      readonly maxCharacters: number;
      readonly urls: ReadonlyArray<string>;
    } | {
      readonly __typename: "GenericToolInput";
      readonly rawInput: any;
    } | {
      readonly __typename: "GitHubActionsLogsToolInput";
      readonly conclusionFilter: ReadonlyArray<string> | null | undefined;
      readonly question: string;
      readonly repoName: string;
      readonly runId: string;
      readonly statusFilter: ReadonlyArray<string> | null | undefined;
    } | {
      readonly __typename: "GitHubActionsRunsToolInput";
      readonly question: string;
      readonly repoName: string;
      readonly runId: string;
    } | {
      readonly __typename: "GrafanaCloudLogsAggregationToolInput";
      readonly gcLogsAggEndIsoStr: string;
      readonly gcLogsAggStartIsoStr: string;
      readonly query: string;
      readonly question: string;
    } | {
      readonly __typename: "GrafanaCloudLogsToolInput";
      readonly gcLogsEndIsoStr: string;
      readonly gcLogsStartIsoStr: string;
      readonly query: string;
      readonly question: string;
    } | {
      readonly __typename: "GrafanaCloudMetricsToolInput";
      readonly gcMetricsEndIsoStr: string;
      readonly gcMetricsStartIsoStr: string;
      readonly query: string;
      readonly question: string;
    } | {
      readonly __typename: "GrafanaCloudSpansAggregationToolInput";
      readonly gcSpansAggEndIsoStr: string;
      readonly gcSpansAggStartIsoStr: string;
      readonly query: string;
      readonly question: string;
    } | {
      readonly __typename: "GrafanaCloudSpansToolInput";
      readonly gcSpansEndIsoStr: string;
      readonly gcSpansStartIsoStr: string;
      readonly query: string;
      readonly question: string;
    } | {
      readonly __typename: "NewRelicChangeTrackingToolInput";
      readonly nrChangeTrackingEndIsoStr: string;
      readonly nrChangeTrackingQuery: string;
      readonly nrChangeTrackingStartIsoStr: string;
      readonly question: string;
    } | {
      readonly __typename: "NewRelicDashboardToolInput";
      readonly nrDashboardId: string;
      readonly question: string;
    } | {
      readonly __typename: "NewRelicLogsAggregationToolInput";
      readonly nrLogsAggEndIsoStr: string;
      readonly nrLogsAggStartIsoStr: string;
      readonly query: string;
      readonly question: string;
    } | {
      readonly __typename: "NewRelicLogsToolInput";
      readonly nrLogsEndIsoStr: string;
      readonly nrLogsStartIsoStr: string;
      readonly query: string;
      readonly question: string;
    } | {
      readonly __typename: "NewRelicMetricsToolInput";
      readonly nrMetricsEndIsoStr: string;
      readonly nrMetricsStartIsoStr: string;
      readonly query: string;
      readonly question: string;
    } | {
      readonly __typename: "NewRelicSpansAggregationToolInput";
      readonly nrSpansAggEndIsoStr: string;
      readonly nrSpansAggStartIsoStr: string;
      readonly query: string;
      readonly question: string;
    } | {
      readonly __typename: "NewRelicSpansToolInput";
      readonly nrSpansEndIsoStr: string;
      readonly nrSpansStartIsoStr: string;
      readonly query: string;
      readonly question: string;
    } | {
      readonly __typename: "NewRelicTransactionsAggregationToolInput";
      readonly nrTransactionsAggEndIsoStr: string;
      readonly nrTransactionsAggStartIsoStr: string;
      readonly query: string;
      readonly question: string;
    } | {
      readonly __typename: "NewRelicTransactionsToolInput";
      readonly nrTransactionsEndIsoStr: string;
      readonly nrTransactionsStartIsoStr: string;
      readonly query: string;
      readonly question: string;
    } | {
      readonly __typename: "QueryCodeToolInput";
      readonly question: string;
      readonly repoName: string;
    } | {
      readonly __typename: "RootlyDashboardToolInput";
      readonly dashboardId: string | null | undefined;
      readonly dashboardSlug: string | null | undefined;
      readonly endIsoStr: string;
      readonly period: string;
      readonly question: string;
      readonly startIsoStr: string;
    } | {
      readonly __typename: "SearchWebToolInput";
      readonly domainFilter: string;
      readonly numResults: number;
      readonly userQuery: string;
    } | {
      readonly __typename: "SentryIssueEventsToolInput";
      readonly issueId: string;
      readonly question: string;
    } | {
      readonly __typename: "SentryIssuesToolInput";
      readonly environment: string;
      readonly projectId: string;
      readonly question: string;
      readonly sentryIssuesEndIsoStr: string;
      readonly sentryIssuesStartIsoStr: string;
      readonly sentryQueryParams: string;
    } | {
      readonly __typename: "SlackChannelContentsToolInput";
      readonly channelId: string;
      readonly question: string;
      readonly threadTs: string | null | undefined;
    } | {
      readonly __typename: "SlackChannelMetadataToolInput";
      readonly channelNameFilter: string | null | undefined;
      readonly question: string;
      readonly slackEndIsoStr: string | null | undefined;
      readonly slackStartIsoStr: string | null | undefined;
    } | {
      readonly __typename: "SlackUsergroupMentionToolInput";
      readonly usergroupHandle: string;
    } | {
      readonly __typename: "TemporalWorkflowHistoryToolInput";
      readonly namespace: string;
      readonly question: string;
      readonly workflowId: string;
      readonly workflowRunId: string | null | undefined;
    } | {
      readonly __typename: "TemporalWorkflowsToolInput";
      readonly namespace: string;
      readonly query: string;
      readonly question: string;
    } | {
      readonly __typename: "UpdateTodoToolInput";
      readonly tasks: ReadonlyArray<any>;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
    readonly link: string | null | undefined;
    readonly name: string;
  } | null | undefined;
  readonly " $fragmentType": "ToolCallSheet_toolCall";
};
export type ToolCallSheet_toolCall$key = {
  readonly " $data"?: ToolCallSheet_toolCall$data;
  readonly " $fragmentSpreads": FragmentRefs<"ToolCallSheet_toolCall">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "question",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "query",
  "storageKey": null
},
v4 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "issueId",
    "storageKey": null
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pipelineSlug",
  "storageKey": null
},
v6 = {
  "alias": "buildNumberInt",
  "args": null,
  "kind": "ScalarField",
  "name": "buildNumber",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logGroupNames",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "repoName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "runId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "namespace",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ToolCallSheet_toolCall",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLMessageToolUse",
      "kind": "LinkedField",
      "name": "toolUse",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "capabilityId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "link",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLCapability",
          "kind": "LinkedField",
          "name": "capability",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "parametersSchema",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "input",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rawInput",
                  "storageKey": null
                }
              ],
              "type": "GenericToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": "ddLogsStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "ddLogsEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                }
              ],
              "type": "DatadogLogsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": "ddLogsAggStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "ddLogsAggEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                }
              ],
              "type": "DatadogLogsAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": "ddMetricsStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "ddMetricsEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                }
              ],
              "type": "DatadogMetricsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": "ddSpansStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "ddSpansEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                }
              ],
              "type": "DatadogSpansToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": "ddSpansAggStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "ddSpansAggEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                }
              ],
              "type": "DatadogSpansAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": "ddRumAggStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "ddRumAggEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                }
              ],
              "type": "DatadogRumAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": "ddEventsStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "ddEventsEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                }
              ],
              "type": "DatadogEventsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": "ddCIPipelineStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "ddCIPipelineEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                }
              ],
              "type": "DatadogCIPipelineEventsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": "ddCIPipelineAggStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "ddCIPipelineAggEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                }
              ],
              "type": "DatadogCIPipelineEventsAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                {
                  "alias": "ddDashboardId",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dashboardId",
                  "storageKey": null
                }
              ],
              "type": "DatadogDashboardToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "notebookId",
                  "storageKey": null
                }
              ],
              "type": "DatadogNotebookToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "monitorId",
                  "storageKey": null
                }
              ],
              "type": "DatadogMonitorToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceName",
                  "storageKey": null
                }
              ],
              "type": "DatadogServiceDependencyToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v4/*: any*/),
              "type": "DatadogErrorTrackingIssueDetailsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": "ddErrorTrackingStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "ddErrorTrackingEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "persona",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "track",
                  "storageKey": null
                }
              ],
              "type": "DatadogErrorTrackingIssuesToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v5/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "queryParams",
                  "storageKey": null
                },
                {
                  "alias": "buildNumberStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "buildNumber",
                  "storageKey": null
                }
              ],
              "type": "BuildkiteBuildsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "stateFilter",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "retryTypeFilter",
                  "storageKey": null
                }
              ],
              "type": "BuildkiteLogsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "contextFilter",
                  "storageKey": null
                }
              ],
              "type": "BuildkiteAnnotationsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "artifactPath",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "searchQuery",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "stepKey",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "jobName",
                  "storageKey": null
                }
              ],
              "type": "BuildkiteArtifactsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "testSuiteSlug",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "testName",
                  "storageKey": null
                }
              ],
              "type": "BuildkiteFlakyTestToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": "cwLogsStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "cwLogsEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                },
                (v7/*: any*/)
              ],
              "type": "CloudWatchLogsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": "cwLogsAggStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "cwLogsAggEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                },
                (v7/*: any*/)
              ],
              "type": "CloudWatchLogsAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": "cwMetricsStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "cwMetricsEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                }
              ],
              "type": "CloudWatchMetricsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": "gcLogsStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "gcLogsEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                }
              ],
              "type": "GrafanaCloudLogsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": "gcLogsAggStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "gcLogsAggEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                }
              ],
              "type": "GrafanaCloudLogsAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": "gcMetricsStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "gcMetricsEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                }
              ],
              "type": "GrafanaCloudMetricsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": "gcSpansAggStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "gcSpansAggEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                }
              ],
              "type": "GrafanaCloudSpansAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": "gcSpansStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "gcSpansEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                }
              ],
              "type": "GrafanaCloudSpansToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": "nrLogsStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "nrLogsEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                }
              ],
              "type": "NewRelicLogsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": "nrLogsAggStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "nrLogsAggEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                }
              ],
              "type": "NewRelicLogsAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                {
                  "alias": "nrDashboardId",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dashboardId",
                  "storageKey": null
                }
              ],
              "type": "NewRelicDashboardToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": "nrMetricsStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "nrMetricsEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                }
              ],
              "type": "NewRelicMetricsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": "nrSpansStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "nrSpansEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                }
              ],
              "type": "NewRelicSpansToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": "nrSpansAggStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "nrSpansAggEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                }
              ],
              "type": "NewRelicSpansAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": "nrTransactionsStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "nrTransactionsEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                }
              ],
              "type": "NewRelicTransactionsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": "nrTransactionsAggStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "nrTransactionsAggEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                }
              ],
              "type": "NewRelicTransactionsAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                {
                  "alias": "nrChangeTrackingQuery",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "query",
                  "storageKey": null
                },
                {
                  "alias": "nrChangeTrackingStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "nrChangeTrackingEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                }
              ],
              "type": "NewRelicChangeTrackingToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v8/*: any*/)
              ],
              "type": "QueryCodeToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v8/*: any*/),
                (v9/*: any*/)
              ],
              "type": "GitHubActionsRunsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v8/*: any*/),
                (v9/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "statusFilter",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "conclusionFilter",
                  "storageKey": null
                }
              ],
              "type": "GitHubActionsLogsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dashboardId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dashboardSlug",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "period",
                  "storageKey": null
                }
              ],
              "type": "RootlyDashboardToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "projectId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "environment",
                  "storageKey": null
                },
                {
                  "alias": "sentryQueryParams",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "queryParams",
                  "storageKey": null
                },
                {
                  "alias": "sentryIssuesStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "sentryIssuesEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                }
              ],
              "type": "SentryIssuesToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v4/*: any*/),
              "type": "SentryIssueEventsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "channelId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "threadTs",
                  "storageKey": null
                }
              ],
              "type": "SlackChannelContentsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "channelNameFilter",
                  "storageKey": null
                },
                {
                  "alias": "slackStartIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIsoStr",
                  "storageKey": null
                },
                {
                  "alias": "slackEndIsoStr",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIsoStr",
                  "storageKey": null
                }
              ],
              "type": "SlackChannelMetadataToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "usergroupHandle",
                  "storageKey": null
                }
              ],
              "type": "SlackUsergroupMentionToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v10/*: any*/),
                (v3/*: any*/)
              ],
              "type": "TemporalWorkflowsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v10/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "workflowId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "workflowRunId",
                  "storageKey": null
                }
              ],
              "type": "TemporalWorkflowHistoryToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "tasks",
                  "storageKey": null
                }
              ],
              "type": "UpdateTodoToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "userQuery",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "domainFilter",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "numResults",
                  "storageKey": null
                }
              ],
              "type": "SearchWebToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "urls",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "maxCharacters",
                  "storageKey": null
                }
              ],
              "type": "FetchWebContentToolInput",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLMessageToolResult",
      "kind": "LinkedField",
      "name": "toolResult",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "content",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasData",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "commandFailed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "artifactId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "groupTags",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ephemeral",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GraphQLMessageToolCall",
  "abstractKey": null
};
})();

(node as any).hash = "c31897970bbe38ed9042fe7d0563a8d9";

export default node;
